// CE-04g-UI-vwap-anchor — read the single `trading_calendars` system-catalog
// row keyed by id='nyse'. The row's `holidays` JSONB drives WTD VWAP's
// post-holiday-Monday anchoring in calcSessionVWAP. The table is a system
// catalog with no per-user data, so we fetch once on mount and treat the
// result as immutable for the session — no user-id key, no refetch on
// auth events.
import { useEffect, useMemo, useState } from 'react'
import { supabase } from '../lib/supabase'

export function useTradingCalendar() {
  const [tradingCalendar, setTradingCalendar] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        const { data, error } = await supabase
          .from('trading_calendars')
          .select('*')
          .eq('id', 'nyse')
          .maybeSingle()
        if (cancelled) return
        setTradingCalendar(error || !data ? null : data)
      } catch {
        if (!cancelled) setTradingCalendar(null)
      } finally {
        if (!cancelled) setLoading(false)
      }
    })()
    return () => { cancelled = true }
  }, [])

  return useMemo(
    () => ({ tradingCalendar, loading }),
    [tradingCalendar, loading]
  )
}
